import React from "react"
import Popup from '../../ppi/ppi-detail/utils/popup'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AccountThemeEditorComponent extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this._manageCheckBox()
    }

    componentDidUpdate() {
        this._manageCheckBox()
    }

    _manageCheckBox() {
        var chkBox = this.refs.checkbox
        chkBox.checked = this.props.value.checked == "checked"
        chkBox.indeterminate = this.props.value.checked == "partial"
        chkBox.disabled = this.props.isServiceAgent ? true : this.props.value.theme_validated
    }

    render() {
        const chkBoxProps = {}
        const previousScenarii = []
        this.props.row.scenarii.filter(s => s.year < this.props.row.scenario.year).map(s => {
            s.scenarii.map(sc => {
                if (sc.validated) previousScenarii.push(sc)
            })
        })
        var previousValues = [], themeValue
        if (previousScenarii.length) {
            previousScenarii/*.sort((a, b) => { return a.year > b.year ? 1 : -1})*/.map(s => {
                if (this.props.value.theme) {
                    if (this.props.row.account) {
                        if (themeValue = s.themes.find(t => t.account_id == this.props.row.account.id && t.theme_id == this.props.value.theme.id)) {
                            previousValues.push({ year: s.year, value: themeValue })
                        }
                    } else if (this.props.row.chapter) {
                        var accounts = s.themes.filter(t => (t.theme_id == this.props.value.theme.id && (this.props.row.accountIds.indexOf(t.account_id) !== -1) && t.receipts == this.props.row.chapter.receipts))
                        var value = 0
                        accounts.map(a => {
                            value += a.amount
                        })
                        previousValues.push({
                            year: s.year,
                            value: { amount: value }
                        })
                    }
                }
            })
        }

        previousValues = previousValues.sort((a, b) => { return (a > b) ? 1 : -1 })
        return (
            <div className="account-year-editor">
                <div className="has-text-grey-lighter" title={this.props.comment}>
                    {this.props.comment && this.props.comment !== ""
                        ? <FontAwesomeIcon icon='comments' />
                        : null
                    }
                </div>
                <div className="aye-identifier" title={this.props.comment}>
                    {this.props.row.account ? this.props.row.account.number : this.props.row.chapter.number}
                </div>
                {this.props.value.amount ? this.props.value.amount : "-"}
                <input
                    disabled={this.props.row.consulted ? true : false}
                    ref="checkbox"
                    type="checkbox"
                    name={(this.props.row.chapter ? "chapter-" + this.props.row.chapter.id : "account-" + this.props.row.account.id) + "-checkbox"}
                    onChange={this.props.onSelectionChange}
                    {...chkBoxProps}
                />
                {this.props.confirmUncheck
                    ? <Popup onHide={this.props.onClosePopup} title={(this.props.row.type == "revenues" ? "Recettes" : "Charges") + " induites"}>
                        <div className="confirm-uncheck-theme-value">
                            <div className="confirm-uncheck-desc">
                                <i className="fa fa-exclamation" />
                                {this._getConfirmPopupContent()}
                            </div>
                            <button className={`button is-primary`} onClick={this.props.onConfirmUncheck}>Déselectionner et supprimer les valeurs</button>
                        </div>
                    </Popup>
                    : null
                }

                {previousValues.length
                    ? <div className="account-year-retro" style={{ marginLeft: "-140px", pointerEvents: "none" }}>
                        <span className="retro-title">Constat retrospectif</span>
                        <div className="retro-values">
                            {previousValues.map(pv => (
                                <div className="retro-value">
                                    <span>{pv.year}</span>
                                    <span>{pv.value.amount ? pv.value.amount : "-"} €</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    : null
                }
            </div>
        )
    }

    _getConfirmPopupContent() {
        var values = []
        if (this.props.row.account) {
            values.push({
                account: this.props.row.account.label,
                gmount: this.props.value.amount
            })
        } else {
            values = this.props.value.theme_values.map(tv => ({
                account: tv.account_name,
                amount: tv.amount
            }))
        }
        return (
            <div className="confirm-uncheck-sentences">
                <span>Attention, des valeurs existent pour les comptes et le thème <strong>{this.props.value.theme.label}</strong> que vous souhaitez désélectionner.</span>
                <span>Détail des valeurs : </span>
                <div className="confirm-values">
                    {values.map(v => (
                        <div className="confirm-value">
                            <div className="confirm-value-account">{v.account}</div>
                            <div className="confirm-value-amount">{v.amount}</div>
                        </div>
                    ))}
                </div>
                <span>Si vous confirmez la déselection, les valeurs seront supprimées définitivement. </span>
            </div>
        )
    }

}

export default AccountThemeEditorComponent



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/account-theme-editor-component.js